import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { EventTileGroup } from 'components/UI/EventTileGroup/EventTileGroup';
import { EventTile } from 'components/UI/EventTile/EventTile';
import { Button } from 'components/UI/Button/Button';
import { Loading } from 'components/UI/Loading/Loading';
import { getFeaturedEventsForContent, getFeaturedEvents } from 'services/FeaturedEventsService';

export const FeaturedEventsForContent = (props) => {
  const { itemId, sectionTitle = '', api = 'filterApi' } = props;

  const [isLoading, setIsLoading] = useState(true);
  const [isBusy, setIsBusy] = useState(false);
  const [eventsData, setEventsData] = useState({ events: [] });
  const [pageNum, setPageNum] = useState(1);

  const isUsingFilterApiUrl = api === 'filterApi';
  const itemsPerPage = 6;

  const eventResultsGroup = (
    <>
      {sectionTitle && <h2 className="featured-events__heading h3">{sectionTitle}</h2>}
      <EventTileGroup collapseOnMobile>
        {eventsData?.events?.map((event, index) => (
          <EventTile {...event} key={index} collapseOnMobile />
        ))}
      </EventTileGroup>
    </>
  );

  const fetchEvents = async () => {
    try {
      const response = isUsingFilterApiUrl
        ? await getFeaturedEventsForContent({
            itemId,
            pageNum,
            itemsPerPage,
          })
        : await getFeaturedEvents();
      setIsLoading(false);
      setEventsData(response);
    } catch (e) {
      console.error(e);
    }
  };

  const fetchMoreEvents = async () => {
    setIsBusy(true);

    try {
      const response = await getFeaturedEventsForContent({
        itemId,
        pageNum,
        itemsPerPage,
      });

      if (response.events.length) {
        setEventsData((prevState) => ({
          ...response,
          events: [...(prevState ? prevState.events : []), ...response.events],
        }));
      }
      setIsBusy(false);
    } catch (e) {
      setIsBusy(false);
      console.error(e);
    }
  };

  const loadMoreEventsButtonHandler = () => {
    setPageNum((prevState) => prevState + 1);
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  useEffect(() => {
    if (pageNum !== 1) {
      fetchMoreEvents();
    }
  }, [pageNum]);

  return (
    <div className="event-tiles-wrap company-seasons container">
      <div className="fullwidth-container text-center">
        {isLoading ? (
          <section>
            <Loading />
          </section>
        ) : (
          eventResultsGroup
        )}
        {((isUsingFilterApiUrl && pageNum < eventsData?.totalPages) || isBusy) && (
          <Button
            onClick={loadMoreEventsButtonHandler}
            variant="primary"
            extendClass={`btn-small load-more-events btn-loading ${
              isBusy ? 'component-loading' : ''
            }`}
            disabled={isBusy}
          >
            <div className="loading-overlay btn-loading-overlay">
              <div className="loading">LOADING</div>
            </div>
            Load more events
          </Button>
        )}
      </div>
    </div>
  );
};

FeaturedEventsForContent.propTypes = {
  itemId: PropTypes.string.isRequired,
  sectionTitle: PropTypes.string,
  api: PropTypes.string,
};

export const FeaturedEventsForContentSC = (props) => {
  const { sitecoreData } = props;
  return <FeaturedEventsForContent {...sitecoreData} />;
};

FeaturedEventsForContentSC.propTypes = {
  sitecoreData: PropTypes.object,
};
